module.exports = __webpack_public_path__ + "5909f667d77fc68679367f6aef781422.png";


//////////////////
// WEBPACK FOOTER
// ./vue/images/phone.png
// module id = 808
// module chunks = 0